import 'twin.macro'

import blankIcon from 'assets/images/landing/blank.png'
import blankCheckIcon from 'assets/images/landing/blank-check.png'
import coinIcon from 'assets/images/landing/coin.png'
import creditCard from 'assets/images/landing/credit-card.png'
import LandingContainer from 'components/UI/Landing/container'
import { ReactNode, useState } from 'react'
import Swiper, { Navigation, Pagination } from 'swiper'
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react'
import tw from 'twin.macro'

import CardAnimationItem from './card-animation-item'
import StepAnimation from './step-animation'
import StepAnimationItem from './step-animation-item'
import StepItem from './step-item'
import StepsNavigation from './steps-navigation'

export type Step = {
  step: number
  title: string
  bodyText: string
  footerText: string
  icon: string
  component: ReactNode
}

const steps: Array<Step> = [
  {
    step: 1,
    title: 'steps-section.first-step.title',
    bodyText: 'steps-section.first-step.note',
    footerText: 'steps-section.takes-few-secs',
    icon: blankIcon,
    component: <StepAnimationItem key='step-1' seconds={30} />
  },
  {
    step: 2,
    title: 'steps-section.second-step.title',
    bodyText: 'steps-section.second-step.note',
    footerText: 'steps-section.takes-few-mins',
    icon: blankCheckIcon,
    component: <StepAnimationItem key='step-2' seconds={90} />
  },
  {
    step: 3,
    title: 'steps-section.third-step.title',
    bodyText: 'steps-section.third-step.note',
    footerText: 'steps-section.takes-few-mins',
    icon: coinIcon,
    component: <StepAnimationItem key='step-3' seconds={180} />
  },
  {
    step: 4,
    title: 'steps-section.last-step.title',
    bodyText: 'steps-section.last-step.note',
    footerText: 'steps-section.immediate-card-release',
    icon: creditCard,
    component: <CardAnimationItem key='step-4' />
  }
]

const StepsSwiper = () => {
  // State
  const [activeIndex, setActiveIndex] = useState(0)

  const handleSwiper = (swiper: Swiper) => {
    setActiveIndex(swiper.activeIndex)
  }

  return (
    <LandingContainer twStyle={tw`relative z-[1]`}>
      <div tw='relative pt-48'>
        <StepAnimation activeIdx={activeIndex} steps={steps} />
      </div>
      <ReactSwiper
        style={{ paddingBottom: 90 }}
        spaceBetween={24}
        slidesPerView={1}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }}
        pagination={{
          dynamicBullets: true,
          clickable: true
        }}
        breakpoints={{
          768: {
            centeredSlides: true,
            slidesPerView: 'auto'
          }
        }}
        modules={[Pagination, Navigation]}
        onActiveIndexChange={handleSwiper}
        className='!overflow-visible'
      >
        <StepsNavigation direction='left' />
        <StepsNavigation direction='right' />
        {steps.map((step, idx) => (
          <SwiperSlide key={step.step} className='md:!w-3/4 lg:!w-1/2'>
            <StepItem step={step} isActive={idx === activeIndex} stepsCount={steps.length - 1} />
          </SwiperSlide>
        ))}
      </ReactSwiper>
    </LandingContainer>
  )
}

export default StepsSwiper
